import { CommonModule } from "@angular/common";
import { Component, HostListener, OnInit } from "@angular/core";
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "src/app/shared/components/snackbar/snackbar.component";
import { TranslateModule } from "@ngx-translate/core";
import { isAppError } from "src/app/core/interceptors/error.interceptor";

@Component({
  selector: "app-floating-consult",
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
  templateUrl: "./floating-consult.component.html",
  styleUrls: ["./floating-consult.component.scss"],
})
export class FloatingConsultComponent implements OnInit {
  isMenuOpen = false;
  isOpen = false;
  isSubmitting = false;
  contact = environment.contact;
  consultForm!: FormGroup;
  private apiURL = environment.apiURL;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.consultForm = this.fb.group({
      fullName: ["", [Validators.required]],
      phoneNumber: ["", [Validators.required, Validators.pattern(/^0[0-9]{9}$/)]],
      emailContact: ["", [Validators.required, Validators.email]],
      quantity: [1, [Validators.required, Validators.min(1)]],
      note: [""]
    });
  }

  toggleMenu(): void {
    if (this.isOpen) {
      this.closeForm();
      return;
    }
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
  }

  openForm(): void {
    this.isMenuOpen = false;
    this.isOpen = true;
  }

  closeForm(): void {
    this.isOpen = false;
    this.isSubmitting = false;
    this.consultForm.reset({ quantity: 1 });
  }

  @HostListener("document:keydown.escape")
  onEscapeKey(): void {
    if (this.isOpen) {
      this.closeForm();
    } else if (this.isMenuOpen) {
      this.closeMenu();
    }
  }

  submitForm(): void {
    if (this.isSubmitting) {
      return;
    }
    if (this.consultForm.invalid) {
      this.consultForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    const cleanApiUrl = this.apiURL.endsWith("/") ? this.apiURL.slice(0, -1) : this.apiURL;
    const targetUrl = `${cleanApiUrl}/api/v1/ContactLead`;

    const formValue = this.consultForm.value;
    const payload = {
      fullName: formValue.fullName,
      phoneNumber: formValue.phoneNumber,
      emailContact: formValue.emailContact,
      quantity: Number(formValue.quantity),
      note: formValue.note || ""
    };

    this.http.post(targetUrl, payload).subscribe({
      next: (res: unknown) => {
        this.isSubmitting = false;
        if (res) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: {
              message: "CONSULT.SUCCESS_MSG",
              type: "success",
            },
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["custom-snackbar"],
          });
          this.closeForm();
        }
      },
      error: (err: unknown) => {
        this.isSubmitting = false;
        // ErrorInterceptor already normalizes and surfaces HTTP errors globally;
        // only show fallback snackbar if error bypassed the interceptor.
        if (!isAppError(err)) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: {
              message: "CONSULT.ERROR_MSG",
              type: "error",
            },
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["custom-snackbar"],
          });
        }
      }
    });
  }
}